import React from "react"
import {CmCollection, SosNews} from "../../../packages/graphql-layer/src";
import CCOHeadline from "../fundamentals/CCOHeadline";
import CCORichText from "../fundamentals/CCORichText/CCORichText";
import CCOContainer from "../fundamentals/CCOContainer";
import PlacementItem from "../layouts/body/PlacementItem";
import C018StandardTeaser from "../content/C018StandardTeaser/C018StandardTeaser";
import C008ImageGallery from "../content/C008ImageGallery/C008ImageGallery";
import CCOH1 from "../fundamentals/CCOH1";
import C003Download from "../content/C003Download/C003Download";
import C021KachelTeaser from "../content/C021KachelTeaser/C021KachelTeaser";
import CCOComponentWrapper from "../fundamentals/CCOComponentWrapper";
import CCOLocationDate from "../fundamentals/CCOLocationDate";
import CCORoofline from "../fundamentals/CCORoofline";
import {t} from "i18next";
import {mapDoctypesGalleryToCollection} from "../../utility/componentUtil";
import C022ContactTeaser from "../content/C022ContactTeaser/C022ContactTeaser";


export interface Props {
    sosNews: SosNews
    CAEGlobalSettings: any,
    csrfToken: string
}


function P013News(props: Props) {
    const isH1Activated = !(props.sosNews as any).eventSettings?.deactivateH1;
    return <>
        <CCOComponentWrapper dataCypress={'newsComponent'} id='main'>
            <CCORoofline roofLine={t("p013_news_overline")} centered={true}/>

            <CCOH1 metadataId={props.sosNews.id} title={props.sosNews.title} isH1Activated={isH1Activated} propertyName='properties.title'></CCOH1>
            <CCOContainer>
                {/* Location, Date */}
                <CCOLocationDate metadataId={props.sosNews.id} location={props.sosNews.location ?? undefined}
                                 propertyName={props.sosNews.extDisplayedDate ? 'properties.extDisplayedDate' : 'properties.modificationDate'}
                                 date={props.sosNews.extDisplayedDate || props.sosNews.modificationDate || ''}/>
                {/* Article */}
                <CCORichText metadataId={props.sosNews.id} textAsTree={props.sosNews.detailText?.textAsTree}
                             propertyName='properties.detailText'
                             docType={"news"}></CCORichText>
            </CCOContainer>
        </CCOComponentWrapper>

        {/* All other related content components */}
        {props.sosNews.relatedContent && props.sosNews.relatedContent.length > 0 ?
            props.sosNews.relatedContent.map((item: any, index: number) => {
                    return <PlacementItem key={index} item={item} CAEGlobalSettings={props.CAEGlobalSettings}
                                          csrfToken={props.csrfToken}/>
                }
            ) : <></>
        }

        {/* Images gallery */}
        {props.sosNews.gallery && props.sosNews.gallery.length > 0 ?
            <C008ImageGallery
                gallery={mapDoctypesGalleryToCollection(props.sosNews.gallery, props.sosNews.id)}
                galleryHeadline={props.sosNews.galleryHeadline ?? undefined}/>
            : <></>}

        {/* Contacts */}
        {props.sosNews.contacts && props.sosNews.contacts.length > 0 ?
            <> {props.sosNews.contacts.map((contact: any, index: number) => {
                return <C022ContactTeaser contactTeaser={contact} key={index}/>
            })} </>
            : <></>}

        {/* Downloads */}
        {props.sosNews.downloads && props.sosNews.downloads.length > 0 ?
            <C003Download cmCollection={{
                items: props.sosNews.downloads!,
                teaserTitle: (props.sosNews as any)?.settings?.['news.downloads'] ?? "Downloads"
            } as CmCollection}/>
            : <></>}

        {/* Related news */}
        {props.sosNews.otherNews && props.sosNews.otherNews.length > 0 ?
            <CCOComponentWrapper>
                {props.sosNews.otherNotificationHeadline ?
                    <CCOHeadline metadataId={props.sosNews.id} headline={props.sosNews.otherNotificationHeadline}></CCOHeadline> : <></>}
                <React.Fragment>
                    {props.sosNews.otherNews.map((item: any, index: number) => {
                            return <C018StandardTeaser key={index} cmTeaser={item}></C018StandardTeaser>
                        }
                    )}
                </React.Fragment>
            </CCOComponentWrapper> : <></>}

        {/* Related Content Items */}
        {props.sosNews.related && props.sosNews.related.length > 0 ?
            <C021KachelTeaser
                cmCollection={{items: props.sosNews.related, teaserTitle: props.sosNews.relatedHeadline} as any}/>
            : null}
    </>
}

export default P013News